module.exports = __webpack_public_path__ + "static_pc/img/br01.2970f008.png";